import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_3 = {
  key: 0,
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_4 = {
  class: "flex flex-wrap gap-3 items-center"
};
const _hoisted_5 = {
  class: "data-table-shell"
};
const _hoisted_6 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_7 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "data-table-td font-mono"
};
const _hoisted_10 = {
  class: "data-table-td font-mono"
};
const _hoisted_11 = {
  class: "data-table-td"
};
const _hoisted_12 = {
  class: "data-table-td is-right font-medium"
};
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_15 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_16 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_21 = {
  class: "text-sm text-slate-500 font-mono"
};
const _hoisted_22 = {
  class: "flex items-center gap-3"
};
const _hoisted_23 = {
  class: "flex-1 overflow-y-auto min-h-0"
};
const _hoisted_24 = {
  key: 0,
  class: "p-12 text-center"
};
const _hoisted_25 = {
  class: "px-6 py-4 border-b border-slate-200"
};
const _hoisted_26 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4"
};
const _hoisted_27 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_28 = {
  class: "font-medium text-slate-900 font-mono text-sm"
};
const _hoisted_29 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_30 = {
  class: "font-medium text-slate-900"
};
const _hoisted_31 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_32 = {
  class: "font-medium text-slate-900 font-mono text-sm"
};
const _hoisted_33 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_34 = {
  class: "font-medium text-slate-900"
};
const _hoisted_35 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_36 = {
  class: "font-medium text-slate-900 text-lg"
};
const _hoisted_37 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_38 = {
  class: "font-medium text-slate-900"
};
const _hoisted_39 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_40 = {
  class: "font-medium text-slate-900"
};
const _hoisted_41 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_42 = {
  class: "font-medium text-slate-900"
};
const _hoisted_43 = {
  key: 0,
  class: "px-6 py-4 border-b border-slate-200"
};
const _hoisted_44 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4"
};
const _hoisted_45 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_46 = {
  class: "font-medium text-slate-900"
};
const _hoisted_47 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_48 = {
  class: "font-medium text-slate-900 font-mono text-sm"
};
const _hoisted_49 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_50 = {
  class: "font-medium text-slate-900"
};
const _hoisted_51 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_52 = {
  class: "font-medium text-slate-900"
};
const _hoisted_53 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_54 = {
  class: "font-medium text-slate-900"
};
const _hoisted_55 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_56 = {
  class: "font-medium text-slate-900"
};
const _hoisted_57 = {
  class: "bg-slate-50 rounded-lg p-3 md:col-span-2"
};
const _hoisted_58 = {
  class: "font-medium text-slate-900"
};
const _hoisted_59 = {
  key: 1,
  class: "px-6 py-4 border-b border-slate-200"
};
const _hoisted_60 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4 mb-4"
};
const _hoisted_61 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_62 = {
  class: "font-medium text-slate-900 font-mono text-sm"
};
const _hoisted_63 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_64 = {
  class: "font-medium text-slate-900"
};
const _hoisted_65 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_66 = {
  class: "font-medium text-slate-900"
};
const _hoisted_67 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_68 = {
  class: "font-medium text-slate-900"
};
const _hoisted_69 = {
  key: 0,
  class: "mt-4"
};
const _hoisted_70 = {
  class: "data-table-shell"
};
const _hoisted_71 = {
  class: "data-table-scroll"
};
const _hoisted_72 = {
  class: "data-table text-sm"
};
const _hoisted_73 = {
  class: "data-table-td font-mono text-slate-900"
};
const _hoisted_74 = {
  class: "data-table-td text-slate-900"
};
const _hoisted_75 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_76 = {
  class: "data-table-td text-right font-medium text-slate-900"
};
const _hoisted_77 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_78 = {
  key: 2,
  class: "px-6 py-4 border-b border-slate-200"
};
const _hoisted_79 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4"
};
const _hoisted_80 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_81 = {
  class: "font-medium text-slate-900"
};
const _hoisted_82 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_83 = {
  class: "font-medium text-slate-900"
};
const _hoisted_84 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_85 = {
  class: "font-medium text-slate-900"
};
const _hoisted_86 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_87 = {
  class: "font-medium text-slate-900"
};
const _hoisted_88 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_89 = {
  class: "font-medium text-slate-900"
};
const _hoisted_90 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_91 = {
  class: "font-medium text-slate-900"
};
const _hoisted_92 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_93 = {
  class: "font-medium text-slate-900"
};
const _hoisted_94 = {
  key: 3,
  class: "px-6 py-4"
};
const _hoisted_95 = {
  class: "data-table-shell"
};
const _hoisted_96 = {
  class: "data-table-scroll"
};
const _hoisted_97 = {
  class: "data-table text-sm"
};
const _hoisted_98 = {
  class: "data-table-td text-slate-900"
};
const _hoisted_99 = {
  class: "status-badge is-info"
};
const _hoisted_100 = {
  class: "data-table-td text-slate-900"
};
const _hoisted_101 = {
  class: "font-medium"
};
const _hoisted_102 = {
  class: "data-table-cell-meta mt-1"
};
const _hoisted_103 = {
  class: "font-medium"
};
const _hoisted_104 = {
  class: "data-table-cell-meta mt-1"
};
const _hoisted_105 = {
  class: "data-table-td text-right text-slate-600"
};
const _hoisted_106 = {
  class: "data-table-td text-right font-medium text-slate-900"
};
const _hoisted_107 = {
  class: "data-table-td"
};
const _hoisted_108 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_109 = {
  class: "bg-slate-100"
};
const _hoisted_110 = {
  class: "px-4 py-3 text-sm font-bold text-slate-900 text-right"
};
const _hoisted_111 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3 bg-slate-50"
};
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import CustomerSelector from '@/components/CustomerSelector/index.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { getCommissionSettlementPage, getCommissionSettlementDetail, retryCommissionRecord, exportCommissionRecord, getCommissionRuleList } from '@/api/commission';
import AppModal from '@/components/AppModal.vue';

// 来源类型

export default {
  __name: 'CommissionRecord',
  setup(__props) {
    const sourceTypes = [{
      value: 'ORDER',
      label: '订单'
    }, {
      value: 'BILLING',
      label: '账单'
    }];

    // 分账状态
    const statusOptions = [{
      value: 0,
      label: '待分账'
    }, {
      value: 1,
      label: '分账中'
    }, {
      value: 2,
      label: '分账完成'
    }, {
      value: 3,
      label: '分账失败'
    }, {
      value: 4,
      label: '已取消'
    }];

    // 搜索表单
    const searchForm = reactive({
      settlementNo: '',
      sourceId: '',
      orderId: '',
      sourceType: '',
      status: '',
      startTime: '',
      endTime: '',
      ruleId: '',
      customerId: '',
      referrerId: '',
      franchiseeId: ''
    });
    const loading = ref(false);
    const recordList = ref([]);
    const pagination = reactive({
      current: 1,
      size: 20,
      total: 0,
      pages: 0
    });

    // 高级筛选
    const showAdvancedFilter = ref(false);

    // 规则列表
    const ruleList = ref([]);

    // 详情弹窗
    const showDetailModal = ref(false);
    const currentRecord = ref(null);
    const detailLoading = ref(false);
    const detailData = ref({});
    const getSourceTypeLabel = type => {
      const found = sourceTypes.find(t => t.value === type);
      return found ? found.label : type;
    };
    const getSourceTypeClass = type => {
      const classes = {
        ORDER: 'status-badge is-info',
        BILLING: 'status-badge is-purple'
      };
      return classes[type] || 'status-badge is-neutral';
    };
    const getStatusLabel = status => {
      const found = statusOptions.find(s => s.value === status);
      return found ? found.label : status;
    };
    const getStatusClass = status => {
      const classes = {
        0: 'status-badge is-neutral',
        1: 'status-badge is-info',
        2: 'status-badge is-success',
        3: 'status-badge is-danger',
        4: 'status-badge is-neutral'
      };
      return classes[status] || 'status-badge is-neutral';
    };
    const getStatusDotClass = status => {
      const classes = {
        0: 'bg-slate-500',
        1: 'bg-blue-500 animate-pulse',
        2: 'bg-green-500',
        3: 'bg-red-500',
        4: 'bg-slate-400'
      };
      return classes[status] || 'bg-slate-500';
    };
    const getSettlementStatusLabel = status => {
      const labels = {
        0: '待结算',
        1: '已结算',
        2: '已取消'
      };
      return labels[status] ?? status;
    };
    const getSettlementStatusClass = status => {
      const classes = {
        0: 'status-badge is-neutral',
        1: 'status-badge is-success',
        2: 'status-badge is-neutral'
      };
      return classes[status] || 'status-badge is-neutral';
    };

    // 计算分账明细总金额
    const getTotalAmount = details => {
      if (!details || !Array.isArray(details)) return 0;
      return details.reduce((sum, detail) => sum + (detail.amount || 0), 0);
    };

    // 获取记录列表
    const fetchRecords = async () => {
      loading.value = true;
      try {
        const params = {
          settlementNo: searchForm.settlementNo || undefined,
          sourceId: searchForm.sourceId ? Number(searchForm.sourceId) : undefined,
          orderId: searchForm.orderId ? Number(searchForm.orderId) : undefined,
          sourceType: searchForm.sourceType || undefined,
          status: searchForm.status !== '' ? Number(searchForm.status) : undefined,
          startTime: searchForm.startTime || undefined,
          endTime: searchForm.endTime || undefined,
          ruleId: searchForm.ruleId ? Number(searchForm.ruleId) : undefined,
          customerId: searchForm.customerId ? Number(searchForm.customerId) : undefined,
          referrerId: searchForm.referrerId ? Number(searchForm.referrerId) : undefined,
          franchiseeId: searchForm.franchiseeId ? Number(searchForm.franchiseeId) : undefined,
          pageNum: pagination.current,
          pageSize: pagination.size
        };
        const data = await getCommissionSettlementPage(params);
        recordList.value = data.records || [];
        pagination.current = data.current;
        pagination.size = data.size;
        pagination.total = data.total;
        pagination.pages = data.pages;
      } catch (error) {
        ElMessage.error(error.message || '获取结算单失败');
      } finally {
        loading.value = false;
      }
    };
    const handleSearch = () => {
      pagination.current = 1;
      fetchRecords();
    };
    const resetSearch = () => {
      searchForm.settlementNo = '';
      searchForm.sourceId = '';
      searchForm.orderId = '';
      searchForm.sourceType = '';
      searchForm.status = '';
      searchForm.startTime = '';
      searchForm.endTime = '';
      searchForm.ruleId = '';
      searchForm.customerId = '';
      searchForm.referrerId = '';
      searchForm.franchiseeId = '';
      pagination.current = 1;
      fetchRecords();
    };
    const handlePageChange = page => {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      fetchRecords();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.current = 1;
      fetchRecords();
    };

    // 查看详情
    const showDetail = async record => {
      currentRecord.value = record;
      showDetailModal.value = true;
      detailLoading.value = true;
      detailData.value = {};
      try {
        const data = await getCommissionSettlementDetail(record.id);
        detailData.value = data || {};
      } catch (error) {
        ElMessage.error(error.message || '获取详情失败');
      } finally {
        detailLoading.value = false;
      }
    };

    // 重试
    const retryRecord = async record => {
      try {
        await retryCommissionRecord(record.id);
        ElMessage.success('已加入重试队列');
        showDetailModal.value = false;
        fetchRecords();
      } catch (error) {
        ElMessage.error(error.message || '重试失败');
      }
    };

    // 导出
    const exportRecord = async record => {
      try {
        await exportCommissionRecord(record.id);
        ElMessage.success('导出成功');
      } catch (error) {
        ElMessage.error(error.message || '导出失败');
      }
    };

    // 加载规则列表
    const loadRules = async () => {
      try {
        const data = await getCommissionRuleList({
          page: 1,
          size: 100
        });
        ruleList.value = data.records || [];
      } catch (error) {
        console.error('加载规则列表失败', error);
      }
    };
    onMounted(() => {
      fetchRecords();
      loadRules();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "结算单查询"), _createElementVNode("p", {
          class: "list-page-description"
        }, "查询结算单记录，查看分账明细和状态")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchRecords
        }, {
          actions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[3] || (_cache[3] = $event => showAdvancedFilter.value = !showAdvancedFilter.value)
          }, _toDisplayString(showAdvancedFilter.value ? '收起筛选' : '高级筛选'), 1)]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: resetSearch
          }, "重置")]),
          extra: _withCtx(() => [showAdvancedFilter.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => searchForm.sourceId = $event),
            type: "text",
            inputmode: "numeric",
            placeholder: "来源ID（精确匹配）",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, searchForm.sourceId]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => searchForm.orderId = $event),
            type: "text",
            inputmode: "numeric",
            placeholder: "订单ID（精确匹配）",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, searchForm.orderId]]), _createVNode(CustomerSelector, {
            modelValue: searchForm.customerId,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => searchForm.customerId = $event),
            placeholder: "请选择客户",
            class: "selector-compact filter-bar-field"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: searchForm.startTime,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => searchForm.startTime = $event),
            type: "datetime",
            format: "YYYY年MM月DD日 HH:mm",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            placeholder: "分账开始时间",
            class: "filter-bar-field form-date form-control-sm"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: searchForm.endTime,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => searchForm.endTime = $event),
            type: "datetime",
            format: "YYYY年MM月DD日 HH:mm",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            placeholder: "分账结束时间",
            class: "filter-bar-field form-date form-control-sm"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: searchForm.ruleId,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => searchForm.ruleId = $event),
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部规则",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ruleList.value, rule => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: rule.id,
                label: rule.name,
                value: rule.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])])])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.settlementNo = $event),
            type: "text",
            placeholder: "请输入结算单号",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchForm.settlementNo]]), _cache[16] || (_cache[16] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: searchForm.sourceType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.sourceType = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sourceTypes, t => {
              return _createVNode(_component_el_option, {
                key: t.value,
                label: t.label,
                value: t.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: searchForm.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, s => {
              return _createVNode(_component_el_option, {
                key: s.value,
                label: s.label,
                value: s.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_cache[22] || (_cache[22] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "结算单号"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "来源编号"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "来源"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "总金额"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "分账状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "分账时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[17] || (_cache[17] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-16 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-right"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded ml-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-20 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "h-8 w-20 bg-slate-200 rounded"
          })], -1)]))]);
        }), 64)) : _createCommentVNode("", true), !loading.value && recordList.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[18] || (_cache[18] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })]), _createElementVNode("span", null, "暂无结算单")])], -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordList.value, record => {
          return _openBlock(), _createElementBlock("tr", {
            key: record.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_9, _toDisplayString(record.settlementNo), 1), _createElementVNode("td", _hoisted_10, _toDisplayString(record.orderNo || record.sourceId), 1), _createElementVNode("td", _hoisted_11, [_createElementVNode("span", {
            class: _normalizeClass(["px-2 py-0.5 rounded text-xs", getSourceTypeClass(record.sourceType)])
          }, _toDisplayString(getSourceTypeLabel(record.sourceType)), 3)]), _createElementVNode("td", _hoisted_12, "¥" + _toDisplayString(record.totalAmount?.toLocaleString()), 1), _createElementVNode("td", _hoisted_13, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", getStatusClass(record.status)])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", getStatusDotClass(record.status)])
          }, null, 2), _createTextVNode(" " + _toDisplayString(record.statusDesc || getStatusLabel(record.status)), 1)], 2)]), _createElementVNode("td", _hoisted_14, _toDisplayString(record.settleTime || '-'), 1), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情",
            onClick: $event => showDetail(record)
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_17), record.status === 3 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-teal",
            title: "重试",
            "aria-label": "重试",
            onClick: $event => retryRecord(record)
          }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          })], -1)]))], 8, _hoisted_18)) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "table-action-button is-neutral",
            title: "导出",
            "aria-label": "导出",
            onClick: $event => exportRecord(record)
          }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })], -1)]))], 8, _hoisted_19)])])]);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": [10, 20, 50],
          "show-pager": pagination.pages > 1,
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "show-pager"])) : _createCommentVNode("", true)]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: showDetailModal.value,
          size: "5xl",
          onClose: _cache[14] || (_cache[14] = $event => showDetailModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_cache[23] || (_cache[23] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "结算单详情", -1)), _createElementVNode("p", _hoisted_21, _toDisplayString(detailData.value.settlementNo || currentRecord.value?.settlementNo), 1)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-sm font-medium", getStatusClass(detailData.value.status)])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-2 h-2 rounded-full mr-1.5", getStatusDotClass(detailData.value.status)])
          }, null, 2), _createTextVNode(" " + _toDisplayString(detailData.value.statusDesc || getStatusLabel(detailData.value.status)), 1)], 2), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[10] || (_cache[10] = $event => showDetailModal.value = false)
          }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_23, [detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[25] || (_cache[25] = [_createElementVNode("div", {
            class: "inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary-100 mb-4"
          }, [_createElementVNode("svg", {
            class: "w-6 h-6 text-primary-600 animate-spin",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })])], -1), _createElementVNode("p", {
            class: "text-slate-500"
          }, "加载中...", -1)]))])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_25, [_cache[34] || (_cache[34] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })]), _createTextVNode(" 基本信息 ")], -1)), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_cache[26] || (_cache[26] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "结算单号", -1)), _createElementVNode("div", _hoisted_28, _toDisplayString(detailData.value.settlementNo || '-'), 1)]), _createElementVNode("div", _hoisted_29, [_cache[27] || (_cache[27] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "来源类型", -1)), _createElementVNode("div", _hoisted_30, _toDisplayString(getSourceTypeLabel(detailData.value.sourceType)), 1)]), _createElementVNode("div", _hoisted_31, [_cache[28] || (_cache[28] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "来源编号", -1)), _createElementVNode("div", _hoisted_32, _toDisplayString(detailData.value.orderNo || detailData.value.sourceId || '-'), 1)]), _createElementVNode("div", _hoisted_33, [_cache[29] || (_cache[29] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "分账规则", -1)), _createElementVNode("div", _hoisted_34, _toDisplayString(detailData.value.ruleName || '-'), 1)]), _createElementVNode("div", _hoisted_35, [_cache[30] || (_cache[30] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "分账总金额", -1)), _createElementVNode("div", _hoisted_36, "¥" + _toDisplayString(detailData.value.totalAmount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_37, [_cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "分账时间", -1)), _createElementVNode("div", _hoisted_38, _toDisplayString(detailData.value.settleTime || '-'), 1)]), _createElementVNode("div", _hoisted_39, [_cache[32] || (_cache[32] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "创建时间", -1)), _createElementVNode("div", _hoisted_40, _toDisplayString(detailData.value.createTime || '-'), 1)]), _createElementVNode("div", _hoisted_41, [_cache[33] || (_cache[33] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "备注", -1)), _createElementVNode("div", _hoisted_42, _toDisplayString(detailData.value.remark || '-'), 1)])])]), detailData.value.customer ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_cache[42] || (_cache[42] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })]), _createTextVNode(" 客户信息 ")], -1)), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_cache[35] || (_cache[35] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户姓名", -1)), _createElementVNode("div", _hoisted_46, _toDisplayString(detailData.value.customer.name || '-'), 1)]), _createElementVNode("div", _hoisted_47, [_cache[36] || (_cache[36] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户编号", -1)), _createElementVNode("div", _hoisted_48, _toDisplayString(detailData.value.customer.customerNo || '-'), 1)]), _createElementVNode("div", _hoisted_49, [_cache[37] || (_cache[37] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "联系电话", -1)), _createElementVNode("div", _hoisted_50, _toDisplayString(detailData.value.customer.phone || '-'), 1)]), _createElementVNode("div", _hoisted_51, [_cache[38] || (_cache[38] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户等级", -1)), _createElementVNode("div", _hoisted_52, _toDisplayString(detailData.value.customer.levelName || '-'), 1)]), _createElementVNode("div", _hoisted_53, [_cache[39] || (_cache[39] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户状态", -1)), _createElementVNode("div", _hoisted_54, _toDisplayString(detailData.value.customer.statusName || '-'), 1)]), _createElementVNode("div", _hoisted_55, [_cache[40] || (_cache[40] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "所属人", -1)), _createElementVNode("div", _hoisted_56, _toDisplayString(detailData.value.customer.ownerUserName || '-'), 1)]), _createElementVNode("div", _hoisted_57, [_cache[41] || (_cache[41] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "地址", -1)), _createElementVNode("div", _hoisted_58, _toDisplayString(detailData.value.customer.address || '') + _toDisplayString(detailData.value.customer.detailAddress || ''), 1)])])])) : _createCommentVNode("", true), detailData.value.plan ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_cache[49] || (_cache[49] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })]), _createTextVNode(" 方案信息 ")], -1)), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_cache[43] || (_cache[43] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "方案编号", -1)), _createElementVNode("div", _hoisted_62, _toDisplayString(detailData.value.plan.planNo || '-'), 1)]), _createElementVNode("div", _hoisted_63, [_cache[44] || (_cache[44] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "方案名称", -1)), _createElementVNode("div", _hoisted_64, _toDisplayString(detailData.value.plan.name || '-'), 1)]), _createElementVNode("div", _hoisted_65, [_cache[45] || (_cache[45] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "总金额", -1)), _createElementVNode("div", _hoisted_66, "¥" + _toDisplayString(detailData.value.plan.totalAmount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_67, [_cache[46] || (_cache[46] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "应付金额", -1)), _createElementVNode("div", _hoisted_68, "¥" + _toDisplayString(detailData.value.plan.payableAmount?.toLocaleString() || '0'), 1)])]), detailData.value.plan.orders && detailData.value.plan.orders.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_cache[48] || (_cache[48] = _createElementVNode("h5", {
            class: "text-xs font-medium text-slate-600 mb-2"
          }, "订单列表", -1)), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("table", _hoisted_72, [_cache[47] || (_cache[47] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th"
          }, "订单编号"), _createElementVNode("th", {
            class: "data-table-th"
          }, "产品名称"), _createElementVNode("th", {
            class: "data-table-th"
          }, "订单类型"), _createElementVNode("th", {
            class: "px-4 py-2 text-right text-xs font-medium text-slate-500"
          }, "订单金额"), _createElementVNode("th", {
            class: "data-table-th"
          }, "执行人员")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData.value.plan.orders, order => {
            return _openBlock(), _createElementBlock("tr", {
              key: order.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_73, _toDisplayString(order.orderNo || '-'), 1), _createElementVNode("td", _hoisted_74, _toDisplayString(order.productNameSnapshot || '-'), 1), _createElementVNode("td", _hoisted_75, _toDisplayString(order.orderType === 'ONCE' ? '一次性服务' : '分期订单'), 1), _createElementVNode("td", _hoisted_76, "¥" + _toDisplayString(order.amount?.toLocaleString() || '0'), 1), _createElementVNode("td", _hoisted_77, _toDisplayString(order.executor?.displayName || '-'), 1)]);
          }), 128))])])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), detailData.value.billing ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_cache[57] || (_cache[57] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
          })]), _createTextVNode(" 账单信息 ")], -1)), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [_cache[50] || (_cache[50] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "账单类型", -1)), _createElementVNode("div", _hoisted_81, _toDisplayString(detailData.value.billing.billingType || '-'), 1)]), _createElementVNode("div", _hoisted_82, [_cache[51] || (_cache[51] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "期次", -1)), _createElementVNode("div", _hoisted_83, _toDisplayString(detailData.value.billing.periodIndex ? `第${detailData.value.billing.periodIndex}期` : '-'), 1)]), _createElementVNode("div", _hoisted_84, [_cache[52] || (_cache[52] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "应收金额", -1)), _createElementVNode("div", _hoisted_85, "¥" + _toDisplayString(detailData.value.billing.amount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_86, [_cache[53] || (_cache[53] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "已收金额", -1)), _createElementVNode("div", _hoisted_87, "¥" + _toDisplayString(detailData.value.billing.paidAmount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_88, [_cache[54] || (_cache[54] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "应收日期", -1)), _createElementVNode("div", _hoisted_89, _toDisplayString(detailData.value.billing.dueDate || '-'), 1)]), _createElementVNode("div", _hoisted_90, [_cache[55] || (_cache[55] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "收款时间", -1)), _createElementVNode("div", _hoisted_91, _toDisplayString(detailData.value.billing.paidTime || '-'), 1)]), _createElementVNode("div", _hoisted_92, [_cache[56] || (_cache[56] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "支付渠道", -1)), _createElementVNode("div", _hoisted_93, _toDisplayString(detailData.value.billing.payChannel || '-'), 1)])])])) : _createCommentVNode("", true), detailData.value.details && detailData.value.details.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_94, [_cache[61] || (_cache[61] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 分账明细 ")], -1)), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createElementVNode("table", _hoisted_97, [_cache[60] || (_cache[60] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
          }, "角色"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
          }, "角色实例"), _createElementVNode("th", {
            class: "px-4 py-3 text-right text-xs font-medium text-slate-500"
          }, "分成比例"), _createElementVNode("th", {
            class: "px-4 py-3 text-right text-xs font-medium text-slate-500"
          }, "分账金额"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
          }, "状态"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
          }, "结算时间")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData.value.details, detail => {
            return _openBlock(), _createElementBlock("tr", {
              key: detail.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_98, [_createElementVNode("span", _hoisted_99, _toDisplayString(detail.roleName || '-'), 1)]), _createElementVNode("td", _hoisted_100, [detail.referrer ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createElementVNode("div", _hoisted_101, _toDisplayString(detail.referrer.name), 1), _createElementVNode("div", _hoisted_102, _toDisplayString(detail.referrer.phone), 1)], 64)) : detail.franchisee ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createElementVNode("div", _hoisted_103, _toDisplayString(detail.franchisee.name), 1), _createElementVNode("div", _hoisted_104, _toDisplayString(detail.franchisee.leader) + " " + _toDisplayString(detail.franchisee.phone), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [_createTextVNode("-")], 64))]), _createElementVNode("td", _hoisted_105, _toDisplayString(detail.ratio) + "%", 1), _createElementVNode("td", _hoisted_106, "¥" + _toDisplayString(detail.amount?.toLocaleString() || '0'), 1), _createElementVNode("td", _hoisted_107, [_createElementVNode("span", {
              class: _normalizeClass(["status-badge", getSettlementStatusClass(detail.status)])
            }, _toDisplayString(detail.statusDesc || getSettlementStatusLabel(detail.status)), 3)]), _createElementVNode("td", _hoisted_108, _toDisplayString(detail.settleTime || '-'), 1)]);
          }), 128))]), _createElementVNode("tfoot", _hoisted_109, [_createElementVNode("tr", null, [_cache[58] || (_cache[58] = _createElementVNode("td", {
            colspan: "3",
            class: "px-4 py-3 text-sm font-medium text-slate-700 text-right"
          }, "合计", -1)), _createElementVNode("td", _hoisted_110, " ¥" + _toDisplayString(getTotalAmount(detailData.value.details)?.toLocaleString() || '0'), 1), _cache[59] || (_cache[59] = _createElementVNode("td", {
            colspan: "2"
          }, null, -1))])])])])])])) : _createCommentVNode("", true)], 64))]), _createElementVNode("div", _hoisted_111, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[11] || (_cache[11] = $event => showDetailModal.value = false)
          }, "关闭"), detailData.value.status === 3 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-danger-secondary",
            onClick: _cache[12] || (_cache[12] = $event => retryRecord(detailData.value))
          }, " 重新分账 ")) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[13] || (_cache[13] = $event => exportRecord(detailData.value))
          }, " 导出明细 ")])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};